import { get } from 'lodash';
import { OON_GROUP_TYPE } from '../constants';

export default function isOONGroup(group) {
  return get(group, 'group_type') === OON_GROUP_TYPE;
}
